/**
 * Returns the first day of each month between two dates (inclusive).
 * @param {dayjs.Dayjs} startDate
 * @param {dayjs.Dayjs} endDate
 * @returns {dayjs.Dayjs[]} Start-of-month dates, one per month in range
 */
export default function getMonthsBetween(startDate, endDate) {
  const start = startDate.startOf('month')
  const end = endDate.startOf('month')
  const monthCount = Math.max(end.diff(start, 'month') + 1, 0)

  return Array.from({ length: monthCount }, (_, index) =>
    start.add(index, 'month')
  )
}
